'use client'

import Marquee from 'react-fast-marquee'
import { marqueeSkillRows } from './skill-data'
import { SkillRibbonIcon } from './skill-icons'

function getSkillRibbonRadius(label: string) {
  // Figma 里这一排按钮存在 80 / 88 两组圆角，不是统一值，这里按实际文案做映射。
  const rounded88Labels = new Set(['周报月报', '汇报总结', '研究展示', '活动复盘', '投放分析'])
  return rounded88Labels.has(label) ? 88 : 80
}

// marquee 自己在客户端渲染并暴露固定锚点，供 Hero 的“浏览全部 Skill”按钮滚动到这里。
export function SkillMarqueeSection() {
  return (
    <section
      id="skill-marquee-section"
      className="relative mx-auto w-full max-w-[1300px] overflow-hidden bg-white pb-16 pt-16 md:pb-20 md:pt-20 xl:pb-[100px] xl:pt-[96px]"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-20 w-12 bg-[linear-gradient(90deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0.98)_20%,rgba(255,255,255,0.88)_46%,rgba(255,255,255,0)_100%)] sm:w-20 lg:w-28 xl:w-[180px]" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-20 w-12 bg-[linear-gradient(270deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0.98)_20%,rgba(255,255,255,0.88)_46%,rgba(255,255,255,0)_100%)] sm:w-20 lg:w-28 xl:w-[180px]" />

      <div className="relative z-10 space-y-8 pb-1">
        {marqueeSkillRows.map((row, rowIndex) => (
          <div key={`skill-row-${rowIndex}`} className="relative">
            <Marquee autoFill pauseOnHover={false} direction={rowIndex === 0 ? 'right' : 'left'} speed={22} style={{ overflow: 'visible' }}>
              {row.map(item => (
                <div
                  key={item.label}
                  className="mx-4 flex h-16 shrink-0 items-center justify-center gap-4 px-6 text-white"
                  style={{
                    width: item.width,
                    borderRadius: getSkillRibbonRadius(item.label),
                    ...item.style
                  }}
                >
                  <SkillRibbonIcon src={item.iconSrc} size={item.iconSize} />
                  <span
                    className="whitespace-nowrap font-medium tracking-[-0.02em]"
                    style={{
                      fontSize: 24,
                      lineHeight: 1.206
                    }}
                  >
                    {item.label}
                  </span>
                </div>
              ))}
            </Marquee>
          </div>
        ))}
      </div>
    </section>
  )
}
